import { config } from '@febos-io/common';

import { useAuthContext } from '../providers';

export function AmplifySubscriber() {
  const { amplifyConfig } = useAuthContext();
  console.log('[AmplifySubscriber] Rendering, about to configure Amplify');
  config.configureAmplify(amplifyConfig);
  console.log('[AmplifySubscriber] configureAmplify called');
  return null;
}

export default AmplifySubscriber;
